import React, { useState } from 'react'
import ProgramPhaseForm from './form'

const ProgramPhaseAdd = props => {
  const [data, setData] = useState({})

  return (
    <div className={'root'}>
      <div className={'content'}>
        <ProgramPhaseForm data={data} setData={setData} {...props} />
      </div>
    </div>
  )
}

export default ProgramPhaseAdd
